import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '../../../../core/services/LocalStorageService';
import { OTS_STAFF_DASHBOARD_STATUS_FILTERS_KEY } from '../constants/ots-staff-dashboard-status-filters-key';
import { OTS_STAFF_ORDER_STATUSES } from '../constants/ots-staff-order-statuses';
import { OtsStaffOrdersStore } from '../stores/OtsStaffOrdersStore';
import { OtsStaffOrderStatus } from '../types';

@Injectable({
  providedIn: 'root'
})
export class OtsStaffDashboardPreferencesService {

  private readonly _localStorageService = inject(LocalStorageService);
  private readonly _otsStaffOrdersStore = inject(OtsStaffOrdersStore);

  public restoreStatusFilters(): void {
    this._otsStaffOrdersStore.statusFilters.set(this.loadStatusFilters());
  }

  public toggleStatus(status: OtsStaffOrderStatus): void {
    const nextStatusFilters = {
      ...this._otsStaffOrdersStore.statusFilters(),
      [status]: !this._otsStaffOrdersStore.statusFilters()[status]
    };
    this.saveStatusFilters(nextStatusFilters);
    this._otsStaffOrdersStore.statusFilters.set(nextStatusFilters);
  }

  public loadStatusFilters(): Record<OtsStaffOrderStatus, boolean> {
    let raw: unknown;

    try {
      raw = this._localStorageService.getItem(OTS_STAFF_DASHBOARD_STATUS_FILTERS_KEY);
    } catch {
      return this.defaultStatusFilters();
    }

    if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) {
      return this.defaultStatusFilters();
    }

    const record = raw as Record<string, unknown>;
    const filters = this.defaultStatusFilters();
    let hasValidEntry = false;

    for (const key of OTS_STAFF_ORDER_STATUSES) {
      const value = record[key];

      if (typeof value === 'boolean') {
        filters[key] = value;
        hasValidEntry = true;
      }
    }

    return hasValidEntry ? filters : this.defaultStatusFilters();
  }

  public saveStatusFilters(filters: Record<OtsStaffOrderStatus, boolean>): void {
    this._localStorageService.setItem(OTS_STAFF_DASHBOARD_STATUS_FILTERS_KEY, filters);
  }

  private defaultStatusFilters(): Record<OtsStaffOrderStatus, boolean> {
    return {
      new: true,
      preparing: true,
      ready: true,
      done: true
    };
  }
}
